// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"8358c3dd","239":"5a9f872a","455":"a70f7fc2","536":"faafa6a4","977":"56f8f06d"}[chunkId] + ".chunk.js";
};